import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useDevice } from './useDevice'
import { useUserStore } from '@/shared/stores/user'
import { usePlatformStore } from '@/shared/stores/platform'

const DESKTOP_NAVBAR_HEIGHT = 61
const MOBILE_UNAUTH_NAVBAR_HEIGHT = 50
export const MOBILE_AUTH_NAVBAR_HEIGHT = 101

export function useAvailableHeight() {
  const route = useRoute()
  const device = useDevice()
  const userStore = useUserStore()
  const platformStore = usePlatformStore()

  const availableHeight = computed(() => {
    if (device.isMobile.value || device.isTabletVertical.value) {
      const mobileNavHeight =
        userStore.user && !route.path.includes('checkout')
          ? MOBILE_AUTH_NAVBAR_HEIGHT
          : MOBILE_UNAUTH_NAVBAR_HEIGHT

      return (
        device.viewportHeight.value -
        mobileNavHeight -
        platformStore.alertBannerHeight
      )
    }

    return (
      device.viewportHeight.value -
      DESKTOP_NAVBAR_HEIGHT -
      platformStore.alertBannerHeight
    )
  })

  return { availableHeight }
}
